import src from "IMAGE";
export default { src, width: 197, height: 99, blurWidth: 8, blurHeight: 4, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAASUlEQVR42n2NQQqAIBQFvf/pDLFS+uVG0c4Qf8JFhBsH3lsNjGHOY/qXuxBTIMmFyMEaPbXVUXDecUYhbDt2seSWf6GjqsO+xAurgHq4NWaoGAAAAABJRU5ErkJggg=="};
